<template>
  <div class="jps-curation-subpage-pager" v-if="pageLength > 0">
    <CurationMediaBlock
      v-if="hasPrevious"
      :curation="curation"
      :page="currentPage - 1"
      :subtitle="{ ja: '前のページ', en: 'Previous' }"
    />
    <div v-else class="jcsp-blank"></div>
    <CurationMediaBlock
      v-if="hasNext"
      :curation="curation"
      :page="currentPage + 1"
      :subtitle="{ ja: '次のページ', en: 'Next' }"
    />
    <div v-else class="jcsp-blank"></div>
  </div>
</template>

<script lang="ts" setup>
const route = useRoute()

interface Props {
  curation: Curation
}
const props = withDefaults(defineProps<Props>(), {
})

const hasPrevious = computed(() => {
  return currentPage.value > 1
})

const hasNext = computed(() => {
  return currentPage.value < pageLength.value
})

const currentPage = computed(() => {
  if (route.params.page) {
    return Number(route.params.page)
  } else {
    return 0
  }
})

const pageLength = computed(() => {
  if (props.curation && props.curation.subPages)
    return props.curation.subPages.length
  return 0
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-curation-subpage-pager {
  /* @include base-content-width(); */
  padding-top: 1.5rem;
  padding-bottom: 4rem;
  display: flex;
  justify-content: space-between;
  .curation-media-block {
    width: 100%;
    border-radius: 0.25rem;
    background-color: $jps-gray-50;
    &:first-child {
      margin-right: 1.5rem;
    }
    &:last-child {
      margin-left: 1.5rem;
    }
  }
  .jcsp-blank {
    width: 100%;
    &:first-child {
      margin-right: 1.5rem;
    }
    &:last-child {
      margin-left: 1.5rem;
    }
  }
}
</style>
